<template>
  <section class="group" v-if="lang_data">
    <div class="card" style="border-radius: 8px; box-shadow: none">
      <div class="card-header">
        <div class="group-menu">
          <div class="group-menu__header">
            <p
              @click="$emit('fly')"
              class="card-header-title is-semibold-16-600-19"
              title="Fly to Map"
            >
              <span class="flyto-btn">
                <i class="far fa-paper-plane"></i>
              </span>
              {{ group.name }}
            </p>
            <a class="card-header-icon" @click="open = !open">
              <svg viewBox="0 0 100 100" class="image is-24x24">
                <use
                  v-if="!open"
                  xlink:href="@/assets/icons/sprite.svg#collapse"
                />
                <use v-else xlink:href="@/assets/icons/sprite.svg#expand" />
              </svg>
              <!-- <img v-else class="mr-10" src="@/assets/icons/caret-active.svg" alt /> -->
            </a>
          </div>
          <div class="group-menu__content">
            <div class="group-menu__content-row">
              <div class="field">
                <input
                  v-model="is_ortho"
                  :checked="is_ortho"
                  class="is-checkradio is-info is-small"
                  type="checkbox"
                  :id="'map-group' + group.uid"
                />
                <label :for="'map-group' + group.uid">
                  <span v-if="lang_data">
                    {{ localization("app-maps", "Maps") }}
                  </span>
                </label>
              </div>
              <div class="field">
                <input
                  v-model="is_features"
                  :checked="is_features"
                  class="is-checkradio is-info is-small"
                  type="checkbox"
                  :id="'feature-group' + group.uid"
                />
                <label :for="'feature-group' + group.uid">
                  <span v-if="lang_data">
                    {{ localization("app-features", "Features") }}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="{ 'card-content-close': !open }" class="card-content">
        <project
          v-for="(project, i) in sort(group.projects)"
          :key="i"
          :index="i"
          :group_index="index"
          :is_group_ortho="is_ortho"
          :is_group_features="is_features"
          :project="project"
        ></project>
      </div>
    </div>
  </section>
</template>
<script>
import Project from "./project.component";
import { mapGetters, mapState, mapMutations } from "vuex";
import _ from "lodash";
export default {
  props: ["group", "index"],
  data: function () {
    return {
      is_ortho: false,
      is_features: false,
      open: false,
    };
  },
  created() {
    if (this.index == 0) this.open = true;
  },
  methods: {
    fly() {
      this.is_ortho = true;
    },
    watch_active_project_and_draw() {
      if (this.draw && this.active_project) {
        this.is_ortho = false;
        this.is_features = false;
      }
    },
    sort(data) {
      if (!data) return [];

      return[
        ..._.orderBy(
          _.filter(data, (p) => p.properties && p.properties.date),
          [(p) => p.properties.date],
          ["desc"]
        ),
        ..._.orderBy(
          _.filter(data, (p) => !(p.properties && p.properties.date)),
          [(p) => p.name],
          ["asc"]
        ),
      ]
    },
  },
  components: {
    project: Project,
  },
  computed: {
    ...mapState(["active_projects", "map", "draw", "active_project"]),
  },
  watch: {
    active_project: function (val) {
      this.watch_active_project_and_draw();
    },
    draw: function (val) {
      this.watch_active_project_and_draw();
    },
  },
};
</script>
<style lang="scss" scoped>
.flyto-btn {
  cursor: pointer;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  color: #555c7e;
}
.group {
  margin: 1rem 1.4rem;
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(92, 126, 247, 0.3);
  .card-header-title {
    margin: 0;
    cursor: pointer;
    text-align: left;
    padding: 0.5rem;
  }
  .active {
    color: #000;
    font-weight: 500;
  }
  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 0.2rem;
    transition: all 0.3s;
    &-close {
      display: none;
    }
  }
  .is-checkradio[type="checkbox"].is-small + label {
    font-size: 14px;
    font-family: Barlow-Medium;
    line-height: 42px;
    font-weight: 500;
    opacity: 0.7;
    color: #171e48;
  }
  .is-checkradio[type="checkbox"].is-small + label::before,
  .is-checkradio[type="checkbox"].is-small + label:before {
    margin-top: 3px;
  }
  .is-checkradio[type="checkbox"].is-small + label::after,
  .is-checkradio[type="checkbox"].is-small + label:after {
    top: 0.40375rem;
  }
}
.group-menu {
  width: 100%;
  &__header {
    user-select: none;
    display: flex;
    justify-content: space-between;
  }
  &__content {
    padding: 0 0.5rem;
    &-row {
      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>
